<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">开机广告管理</div>
          <span class="m-title-s">开机广告信息、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>信息列表
          </div>
          <div class="m-table-btn">
<!--            <el-button @click="openPopup" type="primary" size="">新增诊断信息</el-button>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="imgPath" label="广告图片" width="260">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <img :src="ossURL + scope.row.imgPath" alt="" width="188" height="334" onerror="this.style.display='none'">
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="开启状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1'" type="success">开启</el-tag>
              <el-tag v-if="scope.row.status === '0'" type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="广告图片: " prop="imgPath">
              <div style="display: flex;">
                <div style="width: 30%;">
                  <el-upload
                    drag
                    :action="uploadAction"
                    :headers="myHeaders"
                    accept=".jpg, .png"
                    :limit="1"
                    :file-list="fileLists"
                    :on-success="imgSuccess"
                    :on-remove="imgRemove">
                    <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 130px;">
                      <div>
                        <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
                        <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
                      </div>
                    </div>
                  </el-upload>
                </div>
                <div style="width: 70%">
                  <div style="width: 197px; height: 328px;margin-left: 20px;border-radius: 8px;overflow: hidden;">
                    <img :src="ossURL + form.imgPath" alt="" width="100%" height="100%">
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="图片链接: " prop="imgPath">
              <el-input v-model="form.imgPath" disabled placeholder="输入图片链接"></el-input>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" placeholder="输入备注"></el-input>
            </el-form-item>
            <el-form-item label="开启状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'vipManage',
  data () {
    return {
      openText: '',
      openState: false,
      formLoading: false,
      isLoading: false,
      isStatus: false,
      list: [],
      ossURL: this.$httpConf.ossURL,
      uploadAction: '',
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      fileLists: [],
      form: {
        id: '',
        title: '',
        imgPath: '',
        status: '',
        remarks: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        money: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    // 赋值图片上传路径
    this.uploadAction = this.$httpConf.baseURL + '/advert/uploadImage'
  },
  methods: {
    // 删除图片
    imgRemove () {
      this.form.imgPath = ''
      this.fileLists = []
    },
    // 图片上传成功
    imgSuccess (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.imgPath = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.$message.success('上传成功')
      }
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        imgPath: '',
        status: '',
        remarks: ''
      }
      this.isStatus = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.status = this.isStatus ? '1' : '0'
          _this.formLoading = true
          this.$axios.post('/advert/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = {
        id: row.id,
        title: row.title,
        imgPath: row.imgPath,
        status: row.status,
        remarks: row.remarks
      }
      this.isStatus = row.status === '1'
      this.openState = true
    },
    // 管理员列表
    loadData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/advert/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style>
.el-upload-dragger {
  width: 170px !important;
  height: 130px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/advert/Advert.vue